var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-layout"},[_c('nav',[_c('DashboardMenu')],1),_c('main',{class:{
            bg:
                _vm.$route.name === 'dashboardRfid' ||
                _vm.$route.name === 'dashboardSettings',
        }},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }